<template>
  <a-modal
    title="轨迹行程"
    :visible="showTubeView"
    :width="1200"
    destroyOnClose
    @ok="handleOk"
    @cancel="closeTubeView"
  >
    <a-modal
      title="轨迹查看"
      :visible="showSmallMap"
      :width="800"
      destroyOnClose
      @ok="handleOk2"
      @cancel="handleOk2"
    >
      <TravelMap refs="travelmap" :data="data"></TravelMap>
    </a-modal>
    <a-table
      rowKey="id"
      :scroll="{ y: 180 }"
      :columns="columns"
      :data-source="list"
      :loading="dataListLoading"
      :pagination="pagination"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="openSmallMap(text,record)">查看</a>
      </span>
    </a-table>
  </a-modal>
</template>
<script>
function strToJson(str) {
  var json = eval('(' + str + ')')
  return json
}
import moment from 'moment'
import mixinViewModule from '@/mixin/commonModel'
import TravelMap from './TravelMap'
import { getTaskTravel } from '@/api/manage'
export default {
  mixins: [mixinViewModule],
  components: {
    TravelMap
  },
  props: {},
  data() {
    return {
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '姓名',
          dataIndex: 'name'
        },
        {
          title: '距离（km）',
          dataIndex: 'distance'
        },
        {
          title: '时长',
          dataIndex: 'duration'
        },
        {
          title: '开始时间',
          dataIndex: 'startTime'
        },
        {
          title: '结束时间',
          dataIndex: 'endTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 90,
          scopedSlots: { customRender: 'action' }
        }
      ],
      queryUrl: '/pipe-network/task_travel_trajectory/travel/page',
      showTubeView: false,
      id: '',
      eventTypeList: [],
      assistPersonsList: [],
      query: {
        taskId: '' //任务id
      },
      showSmallMap: false,
      data: []
    }
  },
  computed: {
    rules() {
      return {}
    }
  },
  created() {},
  methods: {
    moment,
    handleOk2(e) {
      e.preventDefault()
      this.showSmallMap = false
    },
    handleOk(e) {
      e.preventDefault()
      this.closeTubeView()
    },
    edit(id) {
      this.showTubeView = true
      console.log(id)
      this.query.taskId = id
      this.$nextTick(() => {
        this.queryList()
      })
    },
    closeTubeView() {
      this.showTubeView = false
      this.showSmallMap = false
    },
    openSmallMap(text, record) {
      var params = { taskId: record.taskId,createUserId:record.createUserId }
      console.log(params)
      getTaskTravel(params)
        .then(({ data }) => {
          // let json = strToJson(
          //   '{"type":"LineString","coordinates":[[113.679399088,25.535766778],[112.689399088,24.545766778]]}'
          // )
          this.showSmallMap = true
          if (data.list.length != 0) {
            let datas = data.list
            let arr = []
            datas.forEach(item => {
              if (item.geoJson) {
                console.log(strToJson(item.geoJson).coordinates)
                arr = arr.concat(strToJson(item.geoJson).coordinates)
              }
            })

            this.data = arr
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
</style>
